import { API_URL_PARTNER } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditPartner from "types/Partner/createEditPartner";

const updateItem = (uuid: string, editedItem: TCreateEditPartner) =>
  apiInstance({
    url: API_URL_PARTNER + uuid,
    method: "put",
    data: editedItem,
  });

export default updateItem;
